import React, {useState, useEffect} from 'react';
import {Grid, TextField, Typography, Button, Box, Alert} from "@mui/material";
import {useDispatch} from "react-redux";
import {setPassword, setupPassword} from "../index";
import {useNavigate, useSearchParams} from "react-router-dom";
import {Link as LinkUI} from "react-router-dom";
import {styled} from "@mui/material/styles";

const Link = styled(LinkUI)(({theme}) => ({
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontSize: '1.2rem',
    '&:hover': {
        cursor: 'pointer',
        color: theme.palette.primary.dark,
    },
}));

export const SetPassword = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("info");
    const [errors, setErrors] = useState({});

    const [data, setData] = useState({
        token: token || null,
        password: '',
        password_confirmation: '',
    });

    useEffect(() => {
        if (token) {
            setData(prev => ({...prev, token}));
        }
    }, [token]);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: null,
        }));
        setMessage('');
        setData({
            ...data,
            [name]: value
        });
    }

    const handleSubmit = async () => {
        if (!data.password || !data.password_confirmation) {
            setErrors({password: 'Password is required', password_confirmation: 'Password confirmation is required'});
            return;
        }

        if (data.password !== data.password_confirmation) {
            setErrors(prevErrors => ({
                ...prevErrors,
                password_confirmation: "Passwords do not match.",
            }));
            return;
        }

        if (data.password.length < 8) {
            setErrors({password: 'Password must be at least 8 characters long'});
            return;
        }

        let res;
        if (data.token) {
            res = await setupPassword({dispatch, data});
        } else {
            res = await setPassword({dispatch, data});
        }

        if (res['success']) {
            setData({
                token: data.token,
                password: '',
                password_confirmation: '',
            });
            setMessage(res.data?.message || res.message || '');
            setStatus(res.status || 'success');
            navigate('/dashboard');
        } else {
            setErrors(res.errors || {});
            setMessage(res.message || '');
            setStatus(res.status || 'error');
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography align={"center"} mb={4} fontWeight={"bold"} className={"title"} variant={"h1"}>
                    {data.token ? 'Set Up Your Account Password' : 'Set Account Password'}
                </Typography>
                <Typography align={"center"} variant={"body1"}>
                    {data.token ? 'Welcome! Please set your password to activate your account.' : 'Please set your new password'}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2}>
                    {message && (
                        <Grid item xs={12}>
                            <Alert severity={status}>{message}</Alert>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <TextField
                            value={data.password}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            required
                            name="password"
                            label="Password"
                            type="password"
                            fullWidth
                            error={!!errors?.password}
                            helperText={errors?.password}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            value={data.password_confirmation}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            required
                            name="password_confirmation"
                            label="Re-enter Password"
                            type="password"
                            fullWidth
                            error={!!errors?.password_confirmation}
                            helperText={errors?.password_confirmation}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            fullWidth={true}
                            variant="contained"
                            disableElevation={true}
                            onClick={handleSubmit}
                            size="large"
                            sx={{height: 50, fontSize: 18, textTransform: "capitalize"}}
                        >
                            Set Password
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{mt: 2, textAlign: 'center'}}>
                            <Typography variant={"body2"}>Remembered your password? <Link to="/login">Login</Link></Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};